import { EraQL } from '@cotera/era';
import { Assert } from '@cotera/utilities';
import { agentSpecialForm } from './agent-special-form';
import { BUILTIN_SPECIAL_FORMS } from './builtin-special-forms';
import { ToolSymbolMap } from './types';
import { toolCallSpecialForm } from './tool-call-special-form';
import _ from 'lodash';
import { IToolResolver } from '../dg/graph/types';

export const buildTypecheckingSpecialForms = (params: {
  tools: ToolSymbolMap;
  toolResolver: IToolResolver;
}): EraQL.Bindings => {
  const { tools, toolResolver } = params;
  const toolSymbolBindings: EraQL.Bindings = _.mapValues<
    ToolSymbolMap,
    EraQL.Item
  >(tools, ({ toolName, toolId }, toolKey) => {
    // Get the tool info (including types) from the resolver
    const toolInfo = toolResolver.getToolInfo(toolId);

    Assert.assert(
      toolInfo !== null,
      `Tool info not found for "${toolKey}" (toolId: ${toolId}). Ensure the tool is registered.`
    );

    const sp = toolCallSpecialForm(
      toolName,
      toolInfo.inputTy,
      toolInfo.outputTy
    );

    const res: EraQL.Item = {
      t: 'special-form',
      sp,
      meta: { toolId, toolName },
    };
    return res;
  });

  const forms: EraQL.Bindings = {
    ..._.mapValues(
      BUILTIN_SPECIAL_FORMS,
      (sp): EraQL.Item => ({ t: 'special-form', sp })
    ),
    agent: { t: 'special-form', sp: agentSpecialForm({ tools }) },
    ...toolSymbolBindings,
  };

  return forms;
};
